import { LinkIcon } from 'lucide-react';
import { useState } from 'react';

import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '~/shadcn/components/ui/tooltip';

/**
 * @param {number} carouselID - The ID of the carousel to display a link for.
 */
function CarouselLink({ carouselID }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const url = `/shop?carousel=${carouselID}`;

    const handleTooltipOpenChange = (open) => {
        if (open && !copied) {
            setTooltipOpen(true);
        } else if (!open) {
            setTooltipOpen(false);
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTooltipOpen(true);
            setTimeout(() => {
                setTooltipOpen(false);
                setTimeout(() => {
                    setCopied(false);
                }, 500);
            }, 2000);
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
        }
    };

    return (
        <div className="flex items-center gap-1 text-xs">
            <TooltipProvider>
                <Tooltip open={tooltipOpen} onOpenChange={handleTooltipOpenChange}>
                    <TooltipTrigger asChild>
                        <button
                            className="flex items-center gap-1 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
                            onClick={handleCopy}
                        >
                            <LinkIcon className="w-4 h-4" />
                            <pre className="text-gray-500 cursor-pointer hover:text-gray-700 transition-colors">
                                {url}
                            </pre>
                        </button>
                    </TooltipTrigger>
                    <TooltipContent className="text-sm">{copied ? 'Copied!' : 'Copy to clipboard'}</TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export default CarouselLink;
